import {
    defaultObjectiveResource,
    useObjectiveActions,
} from '../../../../resource/resources/artifacts/objective/objectiveResource';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import {
    defaultProcessAreaObjectiveAssociationResource,
    useProcessAreaObjectiveAssociationActions,
} from '../../../../resource/resources/artifacts/process_area/processAreaObjectiveAssociationResource';
import { StackedCardsComponent } from '../../../reusable-components/StackedCardsComponent';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import React from 'react';
import { ObjectiveEditDialog } from '../../project/reusable-elements/objective/ObjectiveEditDialog';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';

export const StackedObjectivesView = ({isAdmin, processAreaId, versionId, link}: {
    isAdmin: boolean,
    processAreaId: string | undefined,
    versionId: string | undefined,
    link: string | undefined
}) => {

    const nestedDialog = useNestedDialogFunction();
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();

    const objectiveAssociationActions = useProcessAreaObjectiveAssociationActions();
    const objectiveActions = useObjectiveActions();
    const objectiveAssociationsQuery = objectiveAssociationActions.useGetAllResources(processAreaId)
    const objectivesQuery = objectiveActions.useGetAllResources(versionId);

    const deleteObjectiveAssociation = objectiveAssociationActions.useDeleteResource();
    const addObjectiveAssociation = objectiveAssociationActions.useAddResource();
    const addObjective = objectiveActions.useAddResource();
    const addAssociation = () => OpenModal.SelectionOrCreateModal(
        "Select or Create a Objective",
        objectivesQuery.data?.filter(objective =>
            !(objectiveAssociationsQuery.data
                ?.some(association => association.objective === objective.objectId)))
            .map(objective => ({label: objective.name, value: objective.objectId})) ?? [],
        true,
        null,
        async (value) => {
            if (value && processAreaId) {
                await addObjectiveAssociation.mutateAsync({
                    resource: {
                        ...defaultProcessAreaObjectiveAssociationResource,
                        objective: value
                    },
                    parentId: processAreaId
                })
            }
        },
        async (value, multiLineValue) => {
            if (value && processAreaId && versionId) {
                await addObjective.mutateAsync({
                        resource: {
                            ...defaultObjectiveResource,
                            name: value,
                            description: multiLineValue ?? ""
                        },
                        parentId: versionId
                    },
                    {
                        onSuccess: (result) => {
                            const objectiveObjectId = result?.content?.objectId
                            if (objectiveObjectId) {
                                addObjectiveAssociation.mutateAsync({
                                    resource: {
                                        ...defaultProcessAreaObjectiveAssociationResource,
                                        objective: objectiveObjectId
                                    },
                                    parentId: processAreaId
                                })
                            }
                        },
                    }
                )
            }
        },
        undefined,
        "Name",
        true,
        "Description",
        800
    )

    const onDelete = (id: string) => {
        deleteResourceDialogFunction.deleteResource(
            id, null, ResourceType.PROCESS_AREA_OBJECTIVE_ASSOCIATION, deleteObjectiveAssociation
        )
    }

    const onEdit = (id: string) => {
        const association = objectiveAssociationsQuery.data?.find(value => value.id === id)
        if (association) {
            nestedDialog.showNestedDialog(
                <ObjectiveEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={association.objective}
                    versionedInId={versionId ?? ""}
                />
            );
        }
    }

    return (
        <StackedCardsComponent
            title={"Objectives"}
            data={objectiveAssociationsQuery.data?.map(value => ({
                id: value.id,
                text: objectivesQuery.data?.find(resource => resource.objectId === value.objective)?.name ?? "",
                description: objectivesQuery.data?.find(resource => resource.objectId === value.objective)?.description ?? "",
                img: null
            })) ?? []}
            onAdd={isAdmin ? addAssociation : undefined}
            onDelete={isAdmin ? onDelete : undefined}
            onEdit={isAdmin ? onEdit : undefined}
            link={link}
            section={"objectives"}
        />
    );
};